import { IShipmentMissingInfo } from 'types/FMSGraphqlTypes'
import { IMissingInfoFilters } from './types'

export const SHIPMENTS_PER_PAGE = 20

export const TEST_IDS = {
  loadingState: 'shipments-needing-attention-loading-state',
  emptyState: 'shipments-needing-attention-empty-state',
  pagination: 'shipments-needing-attention-pagination',
  row: 'shipment-needing-atttention-row',
}

export const NEEDS_ATTENTION_FILTERS_MAPPER: Record<IMissingInfoFilters, IShipmentMissingInfo[]> = {
  [IMissingInfoFilters.any]: [],
  [IMissingInfoFilters.driver]: [IShipmentMissingInfo.DriverMissing],
  [IMissingInfoFilters.eta]: [IShipmentMissingInfo.EtaMissing],
  [IMissingInfoFilters.truck]: [IShipmentMissingInfo.TruckMissing],
  [IMissingInfoFilters.vin]: [IShipmentMissingInfo.VinMissing],
  [IMissingInfoFilters.trailer]: [IShipmentMissingInfo.TrailerMissing],
  [IMissingInfoFilters.documents]: [
    IShipmentMissingInfo.PodMissing,
    IShipmentMissingInfo.PodRejected,
  ],
}

export const MISSING_INFORMATION_LABELS_MAPPER: Record<IShipmentMissingInfo, string> = {
  [IShipmentMissingInfo.DriverMissing]: 'Driver',
  [IShipmentMissingInfo.EtaMissing]: 'ETA',
  [IShipmentMissingInfo.TruckMissing]: 'Truck',
  [IShipmentMissingInfo.VinMissing]: 'VIN',
  [IShipmentMissingInfo.TrailerMissing]: 'Trailer',
  [IShipmentMissingInfo.PodMissing]: 'Proof of Delivery',
  [IShipmentMissingInfo.PodRejected]: 'Proof of Delivery',
  [IShipmentMissingInfo.LumperMissing]: 'Lumper',
  [IShipmentMissingInfo.VinMissing]: 'Vin',
}
